export const WEBSITE_OVERLAY_ID = -1;

export const WHITE_TEMPLATE_ID = 316548;
